import ApiService from './ApiService'

export async function apiGetOperationsDashboard() {
    return ApiService.fetchData({
        url: `crm/dashboard/operations/`,
        method: 'get',
    })
}

export async function apiGetServiceConfigs() {
    return ApiService.fetchData({
        url: `crm/serviceconf/`,
        method: 'get',
    })
}

export async function apiGetIndoorServiceConfigs() {
    return ApiService.fetchData({
        url: `crm/serviceconf/?service_group__name__iexact=indoor`,
        method: 'get',
    })
}

export async function apiGetProductConfigs() {
    return ApiService.fetchData({
        url: `crm/productconf/`,
        method: 'get',
    })
}

export async function apiCreateProjet(data, estimateId) {
    return ApiService.fetchData({
        url: `sales/generate_estimate/${estimateId}/approve/`,
        method: 'post',
        data,
    })
}

export async function apiGetProjectsList(data) {
    let params = {
        page: data && data.pageIndex ? data.pageIndex : 1,
        pageSize: data && data.pageSize ? data.pageSize : 10,
        search: data && data.query ? data.query : '',
        created_date__gte:
            data && data.filterData && data.filterData.created_date__gte
                ? new Date(data.filterData.created_date__gte)
                      .toISOString()
                      .slice(0, 10)
                : '',
        created_date__lte:
            data && data.filterData && data.filterData.created_date__lte
                ? new Date(data.filterData.created_date__lte)
                      .toISOString()
                      .slice(0, 10)
                : '',
        proj_type__in:
            data && data.filterData && data.filterData.project_type__in
                ? data.filterData.project_type__in.join(',')
                : [],
        project_status__in:
            data && data.filterData && data.filterData.project_status__in
                ? data.filterData.project_status__in.join(',')
                : [],
    }
    let resData = await ApiService.fetchData({
        url: `crm/project/`,
        method: 'get',
        params,
    })
    let resBackData = {
        data: resData.data && resData.data.results ? resData.data.results : [],
        total: resData.data && resData.data.count ? resData.data.count : 0,
    }
    return resBackData
}

export async function apiGetSearchProjectsList(data) {
    let params = {
        search: data,
    }
    let resData = await ApiService.fetchData({
        url: `/finance/project_search/`,
        method: 'get',
        params,
    })
    return resData
}

export async function apiGetProjectDetails(data) {
    return ApiService.fetchData({
        url: `crm/project/${data.id}/`,
        method: 'get',
    })
}

export async function apiTogglePaymentReminder(data) {
    return ApiService.fetchData({
        url: `crm/project/${data.id}/toggle_payment_reminder/`,
        method: 'patch',
        data: { enable_payment_reminder: data.enable_payment_reminder },
    })
}

export async function apiGetCrmLocations({ search = '' } = {}) {
    return ApiService.fetchData({
        url: `crm/location/?search=${encodeURIComponent(search)}`,
        method: 'get',
    })
}

export async function apiGetCrmProjectActivity(data) {
    return ApiService.fetchData({
        url: `crm/project_activity_log/${data.id}/`,
        method: 'get',
    })
}

export async function apiGetCrmFinanceActivity(data) {
    return ApiService.fetchData({
        url: `crm/finance_activity_log/${data.id}/`,
        method: 'get',
    })
}

export async function apiCreateProjectActivityLogById(data) {
    return ApiService.fetchData({
        url: `crm/project_activity_log/${data.id}/`,
        method: 'post',
        data: { comment: data.comment, activity_type: 'comment' },
    })
}

export async function apiGetSessionName({ search = '' } = {}) {
    return ApiService.fetchData({
        url: `crm/session_name/?search=${encodeURIComponent(search)}`,
        method: 'get',
    })
}

export async function apiGetCrmCalendar(data) {
    return ApiService.fetchData({
        url: `crm/calender/?month=${data.month}&year=${data?.year}`,
        method: 'get',
    })
}
export async function apiGetCrmCalendarById(data) {
    return ApiService.fetchData({
        url: `crm/calender/${data.id}/`,
        method: 'get',
    })
}
export async function apiGetCrmUserList() {
    return ApiService.fetchData({
        url: `core/user_list/`,
        method: 'get',
    })
}

export async function apiUpdateCrmProjectAssign(data) {
    return ApiService.fetchData({
        url: `crm/assign/${data?.id}/`,
        method: 'patch',
        data: {
            shoot_assigned: data?.shoot_assigned || [],
            equipment_assigned: data?.equipment_assigned || [],
        },
    })
}

export async function apiCrmEquipmentAssign(data) {
    return ApiService.fetchData({
        url: `crm/sessions/${data.id}/available-equipment/`,
        method: 'get',
    })
}

export async function apiGetCrmAvailableUserList(data) {
    return ApiService.fetchData({
        url: `crm/sessions/61/available-users/?group=${data?.group || ''}`,
        method: 'get',
    })
}

export async function apiGetCrmTaskList(data) {
    let params = {
        page: data && data.pageIndex ? data.pageIndex : 1,
        pageSize: data && data.pageSize ? data.pageSize : 10,
        search: data && data.query ? data.query : '',
        include_completed: data && data.includeCompleted ? 'true' : '',
        due_date__gte:
            data && data.filterData && data.filterData.due_date__gte
                ? new Date(data.filterData.due_date__gte)
                      .toISOString()
                      .slice(0, 10)
                : '',
        due_date__lte:
            data && data.filterData && data.filterData.due_date__lte
                ? new Date(data.filterData.due_date__lte)
                      .toISOString()
                      .slice(0, 10)
                : '',
        status__in:
            data && data.filterData && data.filterData.status__in
                ? data.filterData.status__in.join(',')
                : [],
        priority__in:
            data && data.filterData && data.filterData.priority__in
                ? data.filterData.priority__in.join(',')
                : [],
        project__in:
            data && data.filterData && data.filterData.project__in
                ? data.filterData.project__in.join(',')
                : [],
        type__in:
            data && data.filterData && data.filterData.type__in
                ? data.filterData.type__in.join(',')
                : [],
        assigned_to__in:
            data && data.filterData && data.filterData.assigned_to__in
                ? data.filterData.assigned_to__in.join(',')
                : [],
    }
    return ApiService.fetchData({
        url: `crm/tasks/`,
        method: 'get',
        params,
    })
}

export async function apiGetCrmTaskCategoryList(data) {
    return ApiService.fetchData({
        url: `crm/task_category/`,
        method: 'get',
    })
}

export async function apiGetCrmTaskDetails(data) {
    return ApiService.fetchData({
        url: `crm/tasks/${data?.id}/`,
        method: 'get',
    })
}

export async function apiGetCrmTaskActivityLog(data) {
    return ApiService.fetchData({
        url: `crm/task_activity_log/${data.id}/`,
        method: 'get',
    })
}

export async function apiGetCrmTaskUsers() {
    return ApiService.fetchData({
        url: `crm/task_users/`,
        method: 'get',
    })
}

export async function apiGetCrmTaskActions(data) {
    return ApiService.fetchData({
        url: `crm/tasks/${data?.task_id}/get_fields/?action=${data?.action}`,
        method: 'get',
    })
}

export async function apiGetCrmSessionAddressById(data) {
    return ApiService.fetchData({
        url: `crm/session/${data?.id}/update_address/`,
        method: 'get',
    })
}
export async function apiUpdateCrmSessionAddressById(data) {
    return ApiService.fetchData({
        url: `crm/session/${data?.id}/update_address/`,
        method: 'patch',
        data: {
            map_location: data?.mapLocation,
            full_address: data?.fullAddress,
        },
    })
}

export async function apiUpdateCrmSessionDateTimeById(data) {
    return ApiService.fetchData({
        url: `crm/session/${data?.id}/update_datetime/`,
        method: 'patch',
        data: {
            start_time: data?.startTime,
            end_time: data?.endTime,
        },
    })
}

export async function apiUpdateCrmAssignByTaskId(data) {
    return ApiService.fetchData({
        url: `crm/tasks/${data?.id}/assign_user/`,
        method: 'patch',
        data: {
            assigned_to: data?.assigned_to,
        },
    })
}

export async function apiUpdateCrmDatesByTaskId(data) {
    return ApiService.fetchData({
        url: `crm/tasks/${data?.id}/assign_dates/`,
        method: 'patch',
        data: {
            start_date: data?.start_date,
            due_date: data?.due_date,
            end_date: data?.end_date,
        },
    })
}

export async function apiGetCrmMyTasks() {
    return ApiService.fetchData({
        url: `crm/tasks/my_tasks/`,
        method: 'get',
    })
}

export async function apiGetCrmTasksPriority() {
    return ApiService.fetchData({
        url: `crm/task_priority/`,
        method: 'get',
    })
}

export async function apiGetCrmTasksStatusByCategory(data) {
    return ApiService.fetchData({
        url: `crm/task_status/?task_category=${data?.task_category || ''}`,
        method: 'get',
    })
}
export async function apiUpdateCrmTasksStatusById(data) {
    return ApiService.fetchData({
        url: `crm/tasks/${data?.id}/update_task_status/`,
        method: 'patch',
        data: {
            status_id: data?.status_id,
            extra_fields: data?.extra_fields || {},
        },
    })
}

export async function apiUpdateCrmTasksPriority(data) {
    return ApiService.fetchData({
        url: `crm/tasks/${data?.id}/assign_priority/`,
        method: 'patch',
        data: {
            priority: data?.priority,
        },
    })
}

export async function apiGetCrmCompletedTasks() {
    return ApiService.fetchData({
        url: `crm/tasks/completed/`,
        method: 'get',
    })
}



export async function apiGetCrmLateTasks() {
    return ApiService.fetchData({
        url: `crm/tasks/late_tasks/`,
        method: 'get',
    })
}


export async function apiCreateTaskActivityLogComment(data) {
  return ApiService.fetchData({
    url: `crm/tasks/${data.task_id}/comment/`,
    method: 'patch',
    data:{comment:data.comment},
  })
}


export async function apiCreateTask(data) {

  return ApiService.fetchData({
    url: 'crm/tasks/',
    method: 'post',
    data,
  })
}

// Messages
export async function apiGetCrmMessages(params) {
  const query = {
    page: params?.pageIndex || 1,
    pageSize: params?.pageSize || 10,
    search: params?.query || '',
    ordering: params?.ordering || '-created_at',
  }
  if (params?.category) query.category = params.category
  return ApiService.fetchData({
    url: 'crm/messages/',
    method: 'get',
    params: query,
  })
}

export async function apiCreateCrmMessage(data) {
  return ApiService.fetchData({
    url: 'crm/messages/',
    method: 'post',
    data,
  })
}

export async function apiSendCrmMessage(id) {
  return ApiService.fetchData({
    url: `crm/messages/${id}/send/`,
    method: 'post',
  })
}

export async function apiUpdateCrmMessage(id, data) {
  return ApiService.fetchData({
    url: `crm/messages/${id}/`,
    method: 'patch',
    data,
  })
}

export async function apiDeleteCrmMessage(id) {
  return ApiService.fetchData({
    url: `crm/messages/${id}/`,
    method: 'delete',
  })
}
